import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Search: 'Search',
  ClearFilter: 'Clear filter',
  Filter: 'Filter',
  Close: 'Close',
  Number: 'Number',
  GreaterOrEqualThan: 'Greater or equal than',
  LesserOrEqualThan: 'Lesser or equal than',
  CompletedOn: 'Completed on',
});

export default messages;
